import { render, staticRenderFns } from "./CompanyProfile3.vue?vue&type=template&id=9cbaa34a&scoped=true&"
import script from "./CompanyProfile3.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile3.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile3.vue?vue&type=style&index=0&id=9cbaa34a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbaa34a",
  null
  
)

export default component.exports